// extracted by mini-css-extract-plugin
export var arrow = "service-module--arrow--0302f";
export var btn = "service-module--btn--282b4";
export var btnBox = "service-module--btnBox--96c73";
export var description = "service-module--description--37da1";
export var hide = "service-module--hide--f27c2";
export var rightArrow = "service-module--rightArrow--93f90";
export var service = "service-module--service--fbf76";
export var serviceImg = "service-module--serviceImg--21d30";
export var smaller = "service-module--smaller--f0749";
export var textBox = "service-module--textBox--08f2f";
export var title = "service-module--title--06241";
export var titleBox = "service-module--titleBox--48188";